<template>
    <v-container>
        <v-row
            align="center"
            justify="center"
        >
            <v-col cols="8">
                <v-card outlined class="mx-auto" max-width="600">
                    <v-card-subtitle>
                        {{titleMode}} etiqueta para anotaciones
                    </v-card-subtitle>
                    <v-card-text>
                        <v-row align="center" justify="center">
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-text-field
                                    v-model="tagDescription"
                                    outlined
                                    dense
                                    label="Tag"
                                    hint="Tag"
                                    required
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                            <v-col
                                cols="12"
                                md="6"
                            >
                                <v-color-picker
                                    v-model="tagColor"
                                    mode.sync="hex"
                                ></v-color-picker>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions v-if="modeAdd">
                            <v-spacer></v-spacer>
                            <v-btn
                                outlined
                                color="green"
                                dark
                                @click="createTag"
                                :disabled="emptyDescription || invalidColor"
                            >
                                Crear
                            </v-btn>
                    </v-card-actions>
                    <v-card-actions v-else>
                            <v-btn
                                outlined
                                color="green"
                                dark
                                @click="closeUpdate"
                            >
                                Cancelar
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                outlined
                                color="green"
                                dark
                                @click="updateTag"
                            >
                                Actualizar
                            </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row
            align="center"
            justify="center"
        >
            <v-col cols="8">
                <v-card outlined class="mx-auto" max-width="600">
                    <v-card-subtitle>
                        Etiquetas
                    </v-card-subtitle>
                    <v-card-text>
                        <v-row>
                            <v-chip
                                v-for="tag in tags"
                                :key="tag._id"
                                class="ma-2"
                                :color="tag.color"
                                close
                                dark
                                label
                                @click="selectToUpdate(tag)"
                                @click:close="removeTag(tag._id)"
                            >
                                {{tag.text}}
                            </v-chip>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
	import moment from 'moment'

	export default {
        name: 'Tags',
        

		data: () => ({
            mode: 'add',
            tagDescription: '',
            tagColor: '#FF0000',
            upDateId: ''
		}),
		
		methods: {
			createTag () {
                const payload = {
                    text: this.tagDescription,
                    color: this.tagColor
                }

                if ( this.emptyDescription )
                    return

                this.$store.dispatch('pushAnnotationTag', payload)
            },

            selectToUpdate ( tag ) {
                this.mode = 'update'
                this.tagDescription = tag.text
                this.tagColor = tag.color
                this.updateTagId = tag._id
            },

            closeUpdate ( ) {
                this.tagDescription = ''
                this.tagColor = '#FF0000'
                this.upDateId = ''
                this.mode = 'add'
            },

			updateTag() {
                const payload = {
                    id: this.updateTagId,
                    text: this.tagDescription,
                    color: this.tagColor
                }

                const defaultTag = this.tags.find( e=> e._id == this.updateTagId )
                
                if (defaultTag.text === 'Nota')
                    return 

                this.$store.dispatch('updateAnnotationTag', payload)
            },

			removeTag(id) {
                const payload = {
                    id: id
                }

                const defaultTag = this.tags.find( e=> e._id == id )
                
                if (defaultTag.text === 'Nota')
                    return 
                
                this.$store.dispatch('removeAnnotationTag', payload)
            }
		},

		computed: {
            tags () {
                return this.$store.getters.annotationTag.filter ( e => e.view )
            },
            emptyDescription () {
                return this.tagDescription == ''
            },

            modeAdd () {
                return this.mode === 'add'
            },

            titleMode () {
                return this.modeAdd ? 'Crear' : 'Editar'
            },

            invalidColor () {
                return this.tagColor === "#FFFFFF"
            }
		},

		filters : {

		},

		created () {
			moment.locale('es-us')
            this.$store.dispatch('pullAnnotationTag')
		}
	}
</script>
